export const ScreenCloudContactUrl = "https://screen.cloud/contact";
